// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loading-player {
  width: 100%;
  padding-top: 56.24%;
}
@media (max-width: 768px) {
  .loading-player {
    padding: 0;
    height: calc(100vh - 3rem);
  }
}

.video-wrapper {
  position: relative;
  width: 100%;
  max-height: 100vh;
}
.video-wrapper .unmute-button-wrapper {
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  width: auto;
  z-index: 1;
  position: absolute;
  text-align: center;
  margin-top: 50px;
}
@media (max-width: 768px) {
  .video-wrapper .unmute-button-wrapper {
    margin-top: 30px;
  }
}
.video-wrapper .vjs-big-play-button {
  display: none;
}

.playerbox-overlay .player-container {
  visibility: none;
  position: absolute;
  top: -9999px;
}
.playerbox-overlay .theo-player-wrapper {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/components/ui/Player/Wrapper.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,mBAAA;AACJ;AACI;EAJJ;IAKQ,UAAA;IACA,0BAAA;EAEN;AACF;;AACA;EACI,kBAAA;EACA,WAAA;EACA,iBAAA;AAEJ;AAAI;EACI,OAAA;EACA,QAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;AAER;AAAQ;EAXJ;IAYQ,gBAAA;EAGV;AACF;AAAI;EACI,aAAA;AAER;;AAGI;EACI,gBAAA;EACA,kBAAA;EACA,YAAA;AAAR;AAGI;EACI,aAAA;AADR","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
